import { render } from "./TakeOutTabbar.vue?vue&type=template&id=2262be44&scoped=true"
import script from "./TakeOutTabbar.vue?vue&type=script&lang=js"
export * from "./TakeOutTabbar.vue?vue&type=script&lang=js"

import "./TakeOutTabbar.vue?vue&type=style&index=0&id=2262be44&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2262be44"]])

export default __exports__